export default __webpack_public_path__ + "static/media/27152922.70d47986.jpg";